const topicRouter = [
  {
    path: '/t',
    name: 'TopicIndex',
    component: () => import('@/views/topic/index')
  },
  {
    path: '/t/:id(\\d+)',
    name: 'TopicDetail',
    component: () => import('@/views/topic/one')
  },
  {
    path: '/t/tag/:tag',
    name: 'TopicTag',
    component: () => import('@/views/topic/tag')
  },
  {
    path: '/t/msg',
    name: 'TopicMsg',
    component: () => import('@/views/topic/msg')
  },
  {
    path: '/t/create',
    name: 'TopicCreate',
    component: () => import('@/views/topic/create')
  },
  {
    path: '/t/edit',
    name: 'TopicEdit',
    component: () => import('@/views/topic/edit')
  }
]

export default topicRouter



// WEBPACK FOOTER //
// ./src/router/modules/topic.js